import { colors } from 'fitify-ui'
import { typographyStyles } from 'fitify-ui/src/typography/generated/Typography'
import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledColumns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 40px;

  ${phone(css`
    flex-direction: column;
    gap: 24px;
  `)};
`

export const StyledColumn = styled.div`
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 24px;
`

export const StyledSubsection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const StyledList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`

export const StyledListItem = styled.li<{ $bulletColor?: string }>`
  position: relative;
  padding: 6px 0 6px 20px;
  color: ${colors.Gray700};
  ${typographyStyles('Text/Body 14')};

  &::before {
    position: absolute;
    top: 12px;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ $bulletColor }) => $bulletColor ?? colors.Blue400};
    content: '';
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${colors.Gray100};
  }
`
